import AdminGroups from 'components/Admin/Groups/AdminGroups';

const AdminGroupsPage = () => {
	return <AdminGroups />;
};

export default AdminGroupsPage;
